import {MODEL_FAMILY_OTHER_END} from '../constants/makeModel';
import {BaseVehicle} from '../types/BaseVehicle';
import {getMakeValue} from './getMakeValue';

/**
 * Helper function to determine the correct modelFamily value based on custom make/model logic
 */
export const getModelFamilyValue = (
  formData: Pick<
    BaseVehicle,
    'make' | 'formMake' | 'customMake' | 'modelFamily' | 'formModelFamily' | 'customModelFamily'
  >
) => {
  if (!formData.customModelFamily || formData.customModelFamily !== formData.formModelFamily) {
    return formData.formModelFamily ?? formData.modelFamily ?? '';
  }

  return `${getMakeValue(formData)}${MODEL_FAMILY_OTHER_END}`;
};
